import React, { useEffect, useState } from "react";
import SearchComponent from "../../components/search";
import Table from '../../components/datatable/datatable'
import { useNavigate } from "react-router-dom";
import { fetchAllApplications } from "../../core/axios/endpoints";
import { RoutesFullPath } from "../../utils/constants";

// Jira-lozenge per aanvraagstatus (semantische kleuren uit de designbrief).
const STATUS_LOZENGE = {
  "In-behandeling": "bg-[#FFF7D6] text-[#7F5F01]",
  "Ingediend-bij-rvo": "bg-brand-subtle text-brand",
  Goedgekeurd: "bg-[#DCFFF1] text-[#1F845A]",
  Afgekeurd: "bg-[#FFECEB] text-[#AE2A19]",
};

const ClientDashboardPage = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const columns = [
    {
      title: "Kvk Nummer",
      dataIndex: "KvkNummer",
      sorter: (a, b) => a.KvkNummer - b.KvkNummer,
    },
    {
      title: "Kenmerk",
      dataIndex: "Kenmerk",
      sorter: (a, b) => a.Kenmerk - b.Kenmerk,
      render: (text) => <span className="font-medium text-ink">{text}</span>,
    },
    {
      title: "Regeling",
      dataIndex: "regling",
      sorter: (a, b) => a.regling - b.regling,
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => a.status - b.status,
      render: (text) => (
        <span
          className={`inline-flex items-center rounded px-1.5 py-px text-[11px] font-bold uppercase tracking-wide ${
            STATUS_LOZENGE[text] ?? "bg-[#091E420F] text-ink-subtle"
          }`}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Aangemaakt",
      dataIndex: "createdAt",
      render: (text) => <span className="text-ink-subtle">{new Date(text).toLocaleDateString()}</span>,
    },
  ];



  const fetchData = async ({ page, pageSize, resetPageSize }, searchText='') => {
    setLoading(true);
    await fetchAllApplications(page,pageSize,searchText).then(async data => {
      const result = await new Promise((resolve) => {
        resolve({
          data: data?.docs?.map((item, index) => ({ ...item, id: index })) || [],
          totalDataCount: data?.totalDocs || 0,
          resetPageSize
        })
      });
      setData(result);
    }).catch(err => {
      
    }).
      finally(() => setLoading(false));
  };



  const handleRowClick = (record) => {
    navigate(`${RoutesFullPath.aanvraagDetails}/${record?._id}`);
  };


  useEffect(() => {

  });

  const handleSearch = (query) => {
    fetchData({ page: 1, pageSize: 10, resetPageSize: false },query);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <header className="mb-6">
            <h1 className="text-2xl font-medium text-ink">Aanvragen</h1>
            <p className="mt-1 text-sm text-ink-subtlest">
              Overzicht van uw subsidie-aanvragen. Klik op een rij voor de details.
            </p>
          </header>
          <div className="mb-4 max-w-md">
            <SearchComponent onSearch={handleSearch} type={'applications'} />
          </div>
          <div className="table-responsive rounded bg-white shadow-card">
            <Table
              columns={columns}
              response={data}
              fetchData={fetchData}
              onRowClick={handleRowClick}
            />
          </div>

        </div>
      </div>


    </>
  );
};

export default ClientDashboardPage;
